import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Web-specific hook for handling navigation on My Trips page.
 * Encapsulates React Router navigation logic.
 */
export function useMyTripsNavigation() {
  const navigate = useNavigate();

  const navigateToEditTrip = useCallback(
    (tripId: string) => {
      navigate(`/trips/${tripId}`);
    },
    [navigate],
  );

  return {
    navigateToEditTrip,
  };
}
